export const removeEmpty = (obj) =>
  Object.keys(obj)
    .filter((k) => obj[k] !== null && obj[k] !== undefined) // Remove undef. and null.
    .reduce(
      (newObj, k) =>
        typeof obj[k] === 'object'
          ? Object.assign(newObj, { [k]: removeEmpty(obj[k]) }) // Recurse.
          : Object.assign(newObj, { [k]: obj[k] }), // Copy value.
      {}
    );

export const ArrToPairs = (arr) =>
  arr.reduce((result, value, index, array) => {
    if (index % 2 === 0) result.push(array.slice(index, index + 2));
    return result;
  }, []);

export const arrFieldsToKeys = (arr, value = null) =>
  arr.reduce((acc, { name }) => {
    return { ...acc, ...{ [name]: value } };
  }, {});

export function getAge(birth, target) {
  const months = target.diff(birth, 'months', true);
  const birthSpan = {
    year: Math.floor(months / 12),
    month: Math.floor(months) % 12,
    day: Math.round((months % 1) * target.daysInMonth(), 0),
  };
  // you can adjust below logic as your requirements by yourself
  if (birthSpan.year < 1 && birthSpan.month < 1) {
    return `${birthSpan.day} day${birthSpan.day > 1 ? 's' : ''}`;
  }
  if (birthSpan.year < 1) {
    return `${birthSpan.month} month${birthSpan.month > 1 ? 's ' : ' '}${
      birthSpan.day
    } day${birthSpan.day > 1 ? 's' : ''}`;
  }
  if (birthSpan.year < 2) {
    return `${birthSpan.year} year${birthSpan.year > 1 ? 's ' : ' '}${
      birthSpan.month
    } month${birthSpan.month > 1 ? 's ' : ''}`;
  }
  return `${birthSpan.year} year${birthSpan.year > 1 ? 's' : ''}`;
}

export const shallowCompare = (obj1, obj2) =>
  Object.keys(obj1).length === Object.keys(obj2).length &&
  Object.keys(obj1).every(
    (key) =>
      Object.prototype.hasOwnProperty.call(obj2, key) && obj1[key] === obj2[key]
  );
